import _ from "lodash";
import { useEffect, useCallback, useState } from "react";

const useLoadTruckMeta = (httpRequest) => {
  const [meta, setMeta] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const loadMeta = useCallback(async () => {
    setIsLoading(true);
    const response = await httpRequest({
      method: 'get',
      url: 'trucks/meta',
    }).finally(() => setIsLoading(false));

    if (response) {
      const meta = _.get(response, 'data.data', {});
      setMeta(meta);
    }
  }, [httpRequest])

  useEffect(() => {
    loadMeta();
  }, [loadMeta])

  return ({ meta, isLoading });
}

export default useLoadTruckMeta;